// extracted by mini-css-extract-plugin
export default {"resizeContact":"Contact_resizeContact__0tHab","Contact":"Contact_Contact__8arur","Maps":"Contact_Maps__Ant3W"};